import * as a from '@mitranim/js/all.mjs'

function bits(ind) {return 1 << a.reqNat(ind)}

/*
We can use up to 53 bits:

  Number.MAX_SAFE_INTEGER.toString(2)
  ->
  11111111111111111111111111111111111111111111111111111

When removing any of these, old bits must never be reused.

When we run out of 53 bits in the first integer, we can allocate another one.
*/
export const DISK_BITS_QUESTIONNAIRE_SUBMITTED      = bits(0)
export const DISK_BITS_ACCEPTED_COOKIE              = bits(1)
export const DISK_BITS_ACCEPT_APP_PROMO_BANNER      = bits(2)
export const DISK_BITS_CLOSED_SUBS_AD_PANEL         = bits(3)
export const DISK_BITS_OPT_INCLUDE_HIDDEN_DISCOUNTS = bits(4)
export const DISK_BITS_PAID_LISTING_MODAL           = bits(5)
export const DISK_BITS_CLOSED_BUY_MEMBERSHIP        = bits(6)
export const DISK_BITS_MSG_ORDER_DESC               = bits(7)
export const DISK_BITS_FESTIVE_PROMO_MODAL          = bits(8)
export const DISK_BITS_NOTICE_SERVICES              = bits(9)
export const DISK_BITS_NOTICE_EVENTS                = bits(10)
export const DISK_BITS_NOTICE_VIDEOS                = bits(11)
export const DISK_BITS_NOTICE_BOOKS                 = bits(12)
export const DISK_BITS_NOTICE_COURSES               = bits(13)
export const DISK_BITS_NOTICE_ARTICLES              = bits(14)
export const DISK_BITS_NOTICE_PRACTITIONERS         = bits(15)
export const DISK_BITS_NOTICE_ORGANIZATIONS         = bits(16)
export const DISK_BITS_NOTICE_PAYMENTS              = bits(17)
export const DISK_BITS_LUMINARIES                   = bits(18)

export const DISK_KEY_OPT_CATS_MAIN_MODE = `optCatsMainMode`
export const DISK_KEY_OPT_CATS_CONCERN_MODE = `optCatsConcernMode`
export const DISK_KEY_PROMO_NAGGED_AT = `promoNaggedAt`
export const DISK_KEY_PROMO_NAG_COUNTDOWN = `promoNagCountdown`
export const DISK_KEY_AI_MSG_ID = `aiMsgId`
export const DISK_KEY_AI_SEARCH_MSG_ID = `aiSearchMsgId`